import { octopusLogs } from '@octopus-sdk/browser-logs'
import { octopusRum } from '@octopus-sdk/browser-rum'

export enum LogLevel {
  TRACE = 'TRACE',
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
  FATAL = 'FATAL',
}

const ENV = process.env.REACT_APP_ENV === 'online' ? 'online' : 'test'

export enum OctopusEventTypeEnum {
  WhiteScreenError = 'WhiteScreenError',
  WhiteScreenReport = 'WhiteScreenReport',
}

class Octopus {
  private initialized = false

  private logsInstance: typeof octopusLogs

  private rumInstance: typeof octopusRum

  constructor() {
    this.logsInstance = octopusLogs
    this.rumInstance = octopusRum
  }

  init() {
    if (this.initialized) {
      console.warn('[OctopusMonitor] 已经初始化，跳过重复初始化')
      return
    }

    const commonConfig = {
      applicationId: '446e8199-f03a-4e54-824d-4c2bb663f3fc',
      clientToken: 'd6d1d1f91d764c65a917be3793c6f0d6',
      service: 'metis-flying-customer-web',
      env: ENV,
      enable: ['test', 'online'].includes(process.env.REACT_APP_ENV as string),
      site: 'octopus-ingest-cn.zhenguanyu.com',
      version: process.env.REACT_APP_COMMIT_HASH,
    }

    this.logsInstance.init({ ...commonConfig } as any)

    this.rumInstance.init({
      ...commonConfig,
      trackUserInteractions: true,
      trackResources: true,
      trackViewsManually: true,
      forwardTracingLogs: true,
      sampleRate: 100,
      allowedTracingUrls: [
        {
          match(value: string) {
            return (
              value.includes('/infra-octopus-rest/') ||
              value.includes('/octopus-ai-rest/')
            )
          },
        },
      ],
      propagators: [
        { type: 'skywalking', skywalkingNamespace: 'default-namespace' },
      ],
    } as any)

    this.initialized = true
  }

  get logger() { return this.logsInstance.logger }
  get logs() { return this.logsInstance }
  get rum() { return this.rumInstance }

  setUser(user: { id: string, name?: string, email?: string, [key: string]: any }) {
    this.logsInstance.setUser?.(user)
    this.rumInstance.setUser?.(user)
  }

  setGlobalContext(context: Record<string, any>) {
    this.logsInstance.setGlobalContext?.(context)
    this.rumInstance.setGlobalContext?.(context)
  }
}

export const formatLogMessage = (level: LogLevel, type: string, params: Record<string, any>) =>
  `[${level}] [${type}] ${JSON.stringify(params)}`

export const octopus = new Octopus()
